export enum ExportMode {
  VisibleArea = 'VisibleArea',
  MarkedArea = 'MarkedArea',
}
